import React, {Component} from 'react';
import axios from "axios";
import Workflow from "../core/Workflow";
import AuthService from "../../AuthService";


class LabelDialog extends Component {
    constructor(props) {
        super(props);

        this.wowkflow = React.createRef();

        this.state = {
            workflowInitData : {
                WORKFLOW_ID: 4,
                PARAM_labelId: this.props.labelId
            },
            labelId: this.props.labelId
        }

        this.coreChange = this.coreChange.bind(this);
        this.coreSubmit = this.coreSubmit.bind(this);
        this.coreExternalCall = this.coreExternalCall.bind(this);
    }

    coreChange(e) {

    }

    async coreExternalCall(method) {
    	await axios.post(AuthService.getUrl('/' + method), {id: this.state.labelId}, AuthService.getAuthHeader()).then(
        	res => {
        		document.location = "/admin/labels";
            }
        );
    }

    coreSubmit(data) {
    }

    render() {
        return (
            <div className="responsiveForm">
                {!!(this.state.errorMessage) &&
                <div className="errorMessage">
                    <span>{this.state.errorMessage}</span>
                </div>
                }
                {!!(this.state.validMessage) &&
                <div className="actionMessage">
                    <span>{this.state.validMessage}</span>
                </div>
                }
                <Workflow   ref={this.wowkflow}
                            initData={this.state.workflowInitData}
                            onChange={this.coreChange}
                            onSubmit={this.coreSubmit}
                            externalCall={this.coreExternalCall}
                            primaryKey={this.state.labelId}/>
            </div>
        );
    }
}

export default LabelDialog;
